import { useState } from "react";
import { useAuth } from "./AuthProvider";


const Login = () => {
  const [input, setInput] = useState({
    username: "",
    password: "",
  });


  const auth = useAuth();
  const handleSubmitEvent = (e) => {
    e.preventDefault();
    if (input.username !== "" && input.password !== "") {
      auth.loginAction(input);
      return;
    }
    alert("pleae provide a valid input");
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl w-1/2  p-6">
      
      <form onSubmit={handleSubmitEvent}>

                    <div className="mb-4">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        id="user-email"
                        name="username"
                        placeholder="Email"
                        aria-describedby="user-email"
                        aria-invalid="false"
                        onChange={handleInput}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      />
                      <div id="user-email" className="sr-only">
                        Please enter a valid username. It must contain at least 6 characters.
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Password *
                      </label>
                      <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Password"
                        aria-describedby="user-password"
                        aria-invalid="false"
                        onChange={handleInput}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      />
                      <div id="user-password" className="sr-only">
                        your password should be more than 6 character
                      </div>

                    </div>


        <button className="px-6 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 rounded-lg transition-all">Submit</button>
      </form>
    </div>
  );
};

export default Login;